import React, { Suspense } from 'react';
import { FaRegListAlt } from 'react-icons/fa';
import { Card, Tabs, LoadingSpinner } from 'components/common';
import InventoryTransactionHeader from './inventory/transaction/TransactionHeader';
import { getInventories } from 'redux/erp/inventorySlice';
import { useAgGrid } from 'hooks/useAgGrid';

const LazyInventoryTransactionList = React.lazy(() => import('./inventory/transaction/TransactionList'));

const InventoryTransactions = () => {

  const {
    gridRef,
    gridApi,
    onGridReady,
    refreshGrid,
    updateRow,
    addRow,
    removeRow,
    clearAll,
    currentParams,
    updateCustomParams
  } = useAgGrid(getInventories);

  return (
    <>
      <InventoryTransactionHeader
        currentParams={currentParams}
        refreshGrid={refreshGrid}
        clearFilter={clearAll}
        addRow={addRow}
      />

      <Card padding="none">
        <Tabs
          variant="underline"
          lazyMount
          navClassName="tw-px-3 tw-pt-2 tw-bg-white"
          contentClassName="tw-bg-slate-50 tw-p-4"
          tabs={[
            {
              label: 'All',
              icon: <FaRegListAlt size={13} />,
              content: (
                <Suspense fallback={<LoadingSpinner message="Loading..." />}>
                  <LazyInventoryTransactionList
                    gridRef={gridRef}
                    gridApi={gridApi}
                    onGridReady={onGridReady}
                    updateRow={updateRow}
                    addRow={addRow}
                    removeRow={removeRow}
                    clearAll={clearAll}
                    refreshGrid={refreshGrid}
                    currentParams={currentParams}
                    updateCustomParams={updateCustomParams}
                  />
                </Suspense>
              ),
            },
          ]}
        />
      </Card>
    </>
  )
}

export default InventoryTransactions;
